export const SEND_GROUP_EMAIL = "SEND_GROUP_EMAIL"
export const GET_GROUP_EMAIL_RECIPIENTS = "GET_GROUP_EMAIL_RECIPIENTS"
export const RECEIVE_GROUP_EMAIL_RECIPIENTS = "RECEIVE_GROUP_EMAIL_RECIPIENTS"
export const UPDATE_GROUP_EMAIL_TYPE = "UPDATE_GROUP_EMAIL_TYPE"
export const TOGGLE_CONFIRM_RECIPIENTS = "TOGGLE_CONFIRM_RECIPIENTS"
export const TURN_OFF_CONFIRM_RECIPIENTS = "TURN_OFF_CONFIRM_RECIPIENTS"
export const TURN_ON_EMAIL_SAVING = "TURN_ON_EMAIL_SAVING"
export const TURN_OFF_EMAIL_SAVING = "TURN_OFF_EMAIL_SAVING"
export const TURN_ON_EMAIL_SENT = "TURN_ON_EMAIL_SENT"
export const TURN_OFF_EMAIL_SENT = "TURN_OFF_EMAIL_SENT"
export const CHANGE_SUBJECT = "CHANGE_SUBJECT"
export const CHANGE_BODY = "CHANGE_BODY"
export const TURN_ON_ATTACHMENT_ERROR = "TURN_ON_ATTACHMENT_ERROR"
export const TURN_OFF_ATTACHMENT_ERROR = "TURN_OFF_ATTACHMENT_ERROR"
export const UPDATE_ATTACHMENTS = "UPDATE_ATTACHMENTS"
export const SET_EMAIL_ERROR_MESSAGE = "SET_EMAIL_ERROR_MESSAGE"
export const INCREMENT_EMAIL_ERROR_COUNT = "INCREMENT_EMAIL_ERROR_COUNT"
export const SET_EMAIL_ERROR_COUNT = "SET_EMAIL_ERROR_COUNT"
export const EMAIL_SENT_RESET = "EMAIL_SENT_RESET"
export const SET_EMAIL_IS_GROUP_TYPE_ON = "SET_EMAIL_IS_GROUP_TYPE_ON"
export const SET_EMAIL_IS_GROUP_TYPE_OFF = "SET_EMAIL_IS_GROUP_TYPE_OFF"
export const FETCH_EMAIL_SUGGESTIONS = "FETCH_EMAIL_SUGGESTIONS"
export const RECEIVE_EMAIL_SUGGESTIONS = "RECEIVE_EMAIL_SUGGESTIONS"
export const CLEAR_SUGGESTIONS = "CLEAR_SUGGESTIONS"

export const clearSuggestions = () => ({
  type: CLEAR_SUGGESTIONS,
})

export const receiveEmailSuggestions = (suggestions) => ({
  type: RECEIVE_EMAIL_SUGGESTIONS,
  suggestions,
})

export const fetchEmailSuggestions = (query) => ({
  type: FETCH_EMAIL_SUGGESTIONS,
  query,
})

export const sendGroupEmail = (params, success, error) => ({
  type: SEND_GROUP_EMAIL,
  params,
  success,
  error,
})

export const receiveGroupEmailRecipients = (recipientsResponse, success, error) => ({
  type: RECEIVE_GROUP_EMAIL_RECIPIENTS,
  recipientsResponse,
  success,
  error,
})

export const getGroupEmailRecipients = (params, success, error) => ({
  type: GET_GROUP_EMAIL_RECIPIENTS,
  params,
  success,
  error,
})

export const updateGroupEmailType = (params, error) => ({
  type: UPDATE_GROUP_EMAIL_TYPE,
  params,
  error,
})

export const toggleConfirmRecipients = () => ({
  type: TOGGLE_CONFIRM_RECIPIENTS,
})

export const turnOffConfirmRecipients = () => ({
  type: TURN_OFF_CONFIRM_RECIPIENTS,
})

export const turnOnEmailSaving = () => ({
  type: TURN_ON_EMAIL_SAVING,
})

export const turnOffEmailSaving = () => ({
  type: TURN_OFF_EMAIL_SAVING,
})

export const turnOnEmailSent = () => ({
  type: TURN_ON_EMAIL_SENT,
})

export const turnOffEmailSent = () => ({
  type: TURN_OFF_EMAIL_SENT,
})

export const changeSubject = (emailSubject) => ({
  type: CHANGE_SUBJECT,
  emailSubject,
})

export const changeBody = (emailBody) => ({
  type: CHANGE_BODY,
  emailBody,
})

export const turnOnAttachmentError = () => ({
  type: TURN_ON_ATTACHMENT_ERROR,
})

export const turnOffAttachmentError = () => ({
  type: TURN_OFF_ATTACHMENT_ERROR,
})

export const updateAttachments = (attachmentIds) => ({
  type: UPDATE_ATTACHMENTS,
  attachmentIds,
})

export const setEmailErrorMessage = (errorMessage) => ({
  type: SET_EMAIL_ERROR_MESSAGE,
  errorMessage,
})

export const setEmailErrorCount = (errorCount) => ({
  type: SET_EMAIL_ERROR_COUNT,
  errorCount,
})

export const incrementEmailErrorCount = () => ({
  type: INCREMENT_EMAIL_ERROR_COUNT,
})

export const emailSentReset = () => ({
  type: EMAIL_SENT_RESET,
})

export const setEmailIsGroupTypeOn = () => ({
  type: SET_EMAIL_IS_GROUP_TYPE_ON,
})

export const setEmailIsGroupTypeOff = () => ({
  type: SET_EMAIL_IS_GROUP_TYPE_OFF,
})
